import Shortcuts from '@/utils/ClassShortcuts';
import shortcutsMixin from '@/mixins/Shortcuts';
import Vue from 'vue';

const shortcuts = new Shortcuts();

Vue.prototype.$shortcuts = shortcuts;
Vue.mixin(shortcutsMixin);
